export default "__VITE_ASSET__CUvWBlQR__"